module.exports = require('./feeTypes');
